export const SampleComponent = () => {
  return (
    <div>
      <p>Sample</p>
    </div>
  );
};
